import { timelineNodes } from '@/mocks/timeline';

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-time-line text-sm"></i> 事件时间线
          </span>
          <h2 className="heading-font mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">海角吃瓜事件始末时间线</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从线索浮现到各方回应、再到真相梳理与后续观察，每一个关键节点我们都按时间顺序如实排列。
          </p>
        </div>

        <div className="relative mx-auto mt-12 max-w-3xl">
          <div className="absolute bottom-0 left-[15px] top-2 w-px bg-background-200 md:left-1/2 md:-translate-x-1/2"></div>
          <div className="space-y-8">
            {timelineNodes.map((node, idx) => (
              <article key={node.id} className={`relative flex flex-col gap-4 pl-12 md:w-1/2 md:pl-0 ${idx % 2 === 0 ? 'md:mr-auto md:pr-10 md:text-right' : 'md:ml-auto md:pl-10'}`}>
                <span className={`absolute left-0 top-1 flex h-[30px] w-[30px] items-center justify-center rounded-full border-4 border-background-50 text-background-50 ${idx % 2 === 0 ? 'md:left-auto md:right-[-15px]' : 'md:left-[-15px]'} bg-primary-500`}>
                  <i className="ri-check-double-line text-xs"></i>
                </span>
                <div className="rounded-lg bg-background-100 p-5">
                  <div className="flex flex-wrap items-center gap-2 md:justify-end">
                    <span className="heading-font text-sm font-bold text-primary-600">{node.date}</span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
                      <i className="ri-price-tag-3-line"></i> {node.tag}
                    </span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
                      {node.verified}
                    </span>
                  </div>
                  <div className={`mt-1 inline-block rounded-md bg-primary-100 px-2 py-0.5 text-xs font-semibold text-primary-700 ${idx % 2 === 0 ? 'md:float-right' : ''}`}>{node.stage}</div>
                  <h3 className="heading-font mt-3 text-lg font-bold text-foreground-950">{node.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.summary}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}